import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { SaveNoteInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const SaveNoteMutation = graphql(`
  mutation SaveNote($input: SaveNoteInput!) {
    saveNote(input: $input) {
      id
      clientId
      meetingId
      content
      title
      createdAt
      updatedAt
      summary
      openTodosCount
      __typename
    }
  }
`);

export function useSaveNote() {
  const [result, saveNoteMutation] = useMutation(SaveNoteMutation);
  const [error, setError] = useState<Error | null>(null);

  const saveNote = useCallback(
    async (input: SaveNoteInput) => {
      setError(null);
      try {
        const response = await saveNoteMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.saveNote;
      } catch (err: unknown) {
        console.error("Failed to save note:", err);
        if (err instanceof Error) {
          setError(err);
        }
        return null;
      }
    },
    [saveNoteMutation],
  );

  return { saveNote, result, error };
}
